import { UnitType } from "../types/units.js";
import { BuildingType } from "../types/buildings.js";
import { ResearchType } from "../types/research.js";
export const UNIT_DEFINITIONS = {
    [UnitType.HOPLITE]: {
        type: UnitType.HOPLITE,
        name: "Hoplite",
        description: "Well-armored heavy infantry. The backbone of any army.",
        attack: 10,
        defense: 14,
        speed: 1,
        carryCapacity: 40,
        cost: { wood: 40, sulfur: 30 },
        trainTime: 180, // 3 min
        isNaval: false,
        prerequisite: { building: { type: BuildingType.BARRACKS, level: 1 } },
    },
    [UnitType.SWORDSMAN]: {
        type: UnitType.SWORDSMAN,
        name: "Swordsman",
        description: "Fast-moving attackers with sharp blades.",
        attack: 16,
        defense: 8,
        speed: 2,
        carryCapacity: 30,
        cost: { wood: 30, sulfur: 50 },
        trainTime: 240, // 4 min
        isNaval: false,
        prerequisite: {
            building: { type: BuildingType.BARRACKS, level: 4 },
            research: ResearchType.SHARPENED_BLADES,
        },
    },
    [UnitType.ARCHER]: {
        type: UnitType.ARCHER,
        name: "Archer",
        description: "Ranged fighters effective against infantry.",
        attack: 12,
        defense: 4,
        speed: 2,
        carryCapacity: 20,
        cost: { wood: 50, sulfur: 25 },
        trainTime: 200, // 3m 20s
        isNaval: false,
        prerequisite: {
            building: { type: BuildingType.BARRACKS, level: 3 },
            research: ResearchType.BRONZE_ARMOR,
        },
    },
    [UnitType.CAVALRY]: {
        type: UnitType.CAVALRY,
        name: "Cavalry",
        description: "Fast mounted warriors. Excellent for flanking and raids.",
        attack: 20,
        defense: 12,
        speed: 4,
        carryCapacity: 60,
        cost: { wood: 80, sulfur: 100, crystal: 20 },
        trainTime: 480, // 8 min
        isNaval: false,
        prerequisite: {
            building: { type: BuildingType.BARRACKS, level: 8 },
            research: ResearchType.FORMATIONS,
        },
    },
    [UnitType.CATAPULT]: {
        type: UnitType.CATAPULT,
        name: "Catapult",
        description: "Siege weapon that deals massive damage to walls.",
        attack: 30,
        defense: 2,
        speed: 0.5,
        carryCapacity: 0,
        cost: { wood: 200, sulfur: 250, marble: 100 },
        trainTime: 900, // 15 min
        isNaval: false,
        prerequisite: {
            building: { type: BuildingType.BARRACKS, level: 10 },
            research: ResearchType.SIEGE_CRAFT,
        },
    },
    [UnitType.CARGO_SHIP]: {
        type: UnitType.CARGO_SHIP,
        name: "Cargo Ship",
        description: "Transport ship for trading resources between cities.",
        attack: 0,
        defense: 4,
        speed: 3,
        carryCapacity: 500,
        cost: { wood: 250, marble: 100 },
        trainTime: 600, // 10 min
        isNaval: true,
        prerequisite: { building: { type: BuildingType.SHIPYARD, level: 1 } },
    },
    [UnitType.WAR_SHIP]: {
        type: UnitType.WAR_SHIP,
        name: "War Ship",
        description: "Armed vessel for naval combat and blockades.",
        attack: 18,
        defense: 10,
        speed: 2,
        carryCapacity: 100,
        cost: { wood: 300, sulfur: 200, marble: 100 },
        trainTime: 900, // 15 min
        isNaval: true,
        prerequisite: {
            building: { type: BuildingType.SHIPYARD, level: 5 },
            research: ResearchType.NAVAL_WARFARE,
        },
    },
};
//# sourceMappingURL=units.js.map